import * as Yup from "yup";

export default Yup.object().shape({
    id: Yup.number(),
    name: Yup.string().required("Name is required"),
    frequency: Yup.string().required("Frequency is required"),
    description: Yup.string(),
    trainingTypeId: Yup.number().min(1, "Please select training type").required("Training Type is required"),
    trainingSubTypeId: Yup.number().nullable(),
    intervalTypeId: Yup.number().min(1, "Please select an interval").required("Interval Type is required"),
});